import { render, staticRenderFns } from "./regionChangeModal.vue?vue&type=template&id=2c5b169b&scoped=true&"
import script from "./regionChangeModal.vue?vue&type=script&lang=js&"
export * from "./regionChangeModal.vue?vue&type=script&lang=js&"
import style0 from "./regionChangeModal.vue?vue&type=style&index=0&id=2c5b169b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5b169b",
  null
  
)

export default component.exports